<script lang="ts">
	import { InvestmentCalculator } from "#lib/web-ui/blocks/investment-calculator/index.js";
</script>

<svelte:head>
	<title>Real Estate vs Stocks Calculator | Fergmar Capital</title>
	<meta
		name="description"
		content="Compare real estate syndication returns vs stocks, rental properties, and private debt. Free investment growth calculator from Fergmar Capital."
	/>
	<meta
		property="og:title"
		content="Investment Calculator: Compare Real Estate vs Stocks | Fergmar Capital"
	/>
	<meta
		property="og:description"
		content="Compare real estate syndication returns vs stocks, rental properties, and private debt. Free investment growth calculator."
	/>
	<meta name="twitter:title" content="Investment Calculator: Compare Real Estate vs Stocks" />
	<meta
		name="twitter:description"
		content="Compare real estate syndication returns vs stocks, rental properties, and private debt. Free calculator."
	/>

	{@html `<script type="application/ld+json">${JSON.stringify({
		"@context": "https://schema.org",
		"@type": "WebApplication",
		name: "Fergmar Capital Investment Calculator",
		description:
			"Free tool to compare real estate syndication returns against stocks, rental properties, and private debt over time.",
		url: "https://fergmarcapital.com/calculator",
		applicationCategory: "FinanceApplication",
		operatingSystem: "Any",
		offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
		provider: {
			"@type": "Organization",
			name: "Fergmar Capital",
			url: "https://fergmarcapital.com"
		}
	})}</script>`}
</svelte:head>

<p class="sr-only">
	Fergmar Capital's free investment comparison calculator lets investors compare projected returns
	across real estate syndications, stocks, rental properties, and private debt. Adjust annual
	return rates and investment amounts to see projected growth over time.
</p>

<InvestmentCalculator title="Real Estate vs Stocks: Investment Growth Calculator" />
